let PfChatbotPlugin = {};

PfChatbotPlugin.install = function (Vue, {router, store}) {

    let pluginData = {
        // tmpConversationScrollTop: 0,

        // "pluginData.oldConversationMsgCount" keeps the number of conversation messaged at the moment when the user
        // chooses an answer (before adding the chosen answer or the next question to Conversation List). This value
        // is used to compute the delay needed when appending the chosen answer and then received any received
        // conversation messages (i.e. the next question) to Conversation List. It's specially important when multiple
        // conversation messages has to be appended at once, because using this we can make each message to wait for the
        // previous one to be shown.
        oldConversationMsgCount: 0,
        // // "pluginData.answerListComputedDelay" is the total delay (in milliseconds) of conversation messages that are
        // // appended when the user chooses an answer. So this will tell us how many milliseconds we must wait before
        // // showing the new answer list (we must wait until all new conversation messages are visible).
        // answerListComputedDelay: 0,

        // oldConvListPaddingBottom: null,
        oldConvListHeight: null,
        oldAnswerListHeight: null,
    };



    let handleAnswerClick = () => {

        // Store some values before new content is added to page. We will need them later, after the new content is added.
        let convList = document.querySelector('.chatbot-conversation-msg-list');
        let answerList = document.querySelector('.chatbot-answer-list');
        let convLastMessage = convList.querySelector('.conversation-msg--last');

        pluginData.oldConvListHeight = convList.offsetHeight; // Includes paddings.
        pluginData.oldAnswerListHeight = answerList.offsetHeight;
        pluginData.oldConvLastMsgHeight = convLastMessage.offsetHeight;



        pluginData.oldConversationMsgCount = document.querySelectorAll('.chatbot-conversation-msg-list .conversation-msg:not(.conversation-msg--clone)').length;


        // @TODO | We stored some values that we will need later, now we have to hide existing answer list, before it's content will be replaced.
        // @TODO | We need to hide it first in order to avoid flickering or unwanted content movements when new answer list content is displayed.

        // Before hiding the answer list, we must set it's height to stay unchanged even when the answer options
        // are removed (i.e. when the user clicked an answer and the current set of answer options is replaced with
        // another one that will be requested from the API). Otherwise, it will flicker or it will do some unwanted scrolling jumps.

        answerList.style.minHeight = answerList.offsetHeight + 'px';

        hideAnswerList();

        store.commit('ChatBotStore/setMoreContentAvailable', false); // Hide "More Content" icon.

        // Read if was an Edit action
        let isEditAction = store.getters["ChatBotStore/getIsEditAction"];

        // Don't scroll at Edit action
        if (isEditAction !== true) {

            // iOS Safari make scroll also when is not more content to have scroll.
            // Make the test to do the scroll only when is needed.
            let heightOverVisibleArea = getHeightOverVisibleArea();
            if (heightOverVisibleArea > 0) {

                // Scroll after answer provided the last question into visible area.
                // Useful when last question is above and the Sticky question was displayed
                // let elemLastConversationMessage = document.querySelector('.chatbot-conversation-msg-list .conversation-msg--last');
                // let newScrollValue = elemLastConversationMessage.offsetTop;
                let firstConvMsgPreparedForSticky = document.querySelector('.chatbot-conversation-msg-list .conversation-msg.conversation-msg--prepared-for-sticky');
                if (firstConvMsgPreparedForSticky) {
                    let newScrollValue = firstConvMsgPreparedForSticky.offsetTop;
                    console.log("newScrollValue = " + newScrollValue);
                    window.scrollTo(0, newScrollValue);
                }

            }
        }

    };


    let waitForAnswerListToBeShown = () => {
        let promise = new Promise((resolve, reject) => {

            let intervalId = setInterval(() => {

                let chatbotPageContentElem = document.querySelector(".chatbot-page-content"); // animate-hide-answer-list
                if (!chatbotPageContentElem.classList.contains("animate-hide-answer-list")) {
                    // It's shown.
                    clearInterval(intervalId);
                    setTimeout(() => { // Wait a little more because of answer list animation.
                        resolve();
                    }, 700);
                }

            }, 20);

        });

        return promise;
    };


    /**
     * Use this function when you need to be sure that the last conversation message element has been created before running some other code that requires it to exist in the page.
     * @param {Boolean} mustBeVisible - If this is true, wait until the last conversation message element is visible (opacity = 1), not only created.
     * @return {Promise}
     */
    let waitForLastConvMsgToExist = (mustBeVisible) => {

        let promise = new Promise((resolve, reject) => {
            const millisecondsInterval = 20; // How often should we check if last conversation message element has been created. 20 means we will re-check after each 20 milliseconds, until the element is found.
            const millisecondsTimeout = 3600000; // 1 hour. This value can be adjusted, it can be lower. Maybe 1 or 2 minutes is a better value, or even less?
            let millisecondsWaited = 0;
            let elemLastConversationMessage = null;

            let intervalId = setInterval(() => {
                millisecondsWaited = millisecondsWaited + millisecondsInterval;
                if (millisecondsWaited >= millisecondsTimeout) {
                    clearInterval(intervalId);
                    reject("TIMEOUT waiting for '.last-conversation-message' to be created.");
                }
                else {
                    elemLastConversationMessage = document.querySelector('.chatbot-conversation-msg-list .conversation-msg--last');
                    if (elemLastConversationMessage !== null) {

                        if (mustBeVisible === true) {
                            // The element's html code has been added to page, but we have to make sure that the element is visible.
                            if (elemLastConversationMessage.offsetParent !== null && window.getComputedStyle(elemLastConversationMessage).opacity == "1") { // offsetParent is null when the element has display:hidden (except when the element is position:fixed).
                                clearInterval(intervalId);

                                setTimeout(() => {
                                    resolve();
                                }, 1000);
                            }
                        }
                        else {
                            // The element's html code has been added to page, we don't care if the element is visible or not.
                            clearInterval(intervalId);

                            setTimeout(() => {
                                resolve();
                            }, 1000);
                        }
                    }
                }
            }, millisecondsInterval);
        });

        return promise;
    };



    let answerListUpdated = (mustSetSpacingOnly) => {

        waitForLastConvMsgToExist().then(() => {


            // _______________________________________
            //
            // @TODO Here comes the code for border-radius for consecutive messages having the same type. See old plugin (PfChatbotHelperPlugin.js -> answerListUpdated() method - you can copy the code from there and just adapt it to work with the new html structure).
            // @TODO ...
            // _______________________________________


            let firstConvMsgPreparedForSticky = document.querySelector('.chatbot-conversation-msg-list .conversation-msg.conversation-msg--prepared-for-sticky');
            // For study access we don't show the urgentPopup so don't set the verticalSpacing to get rid of unnecessary scrolling
            const studyAccess = store.getters['TranslationStore/getAppPropertyStudyAccess'];
            const urgentData = store.getters['AssessmentAlertsStore/getUrgentData'];
            if (studyAccess && urgentData != null) {
                let scrollHeight = Math.max(
                    document.body.scrollHeight,
                    document.body.offsetHeight,
                    document.documentElement.clientHeight,
                    document.documentElement.scrollHeight,
                    document.documentElement.offsetHeight
                );
                let maxScrollTop = scrollHeight - window.innerHeight;
                Vue.UtilitiesPlugin.smoothScrollTo(maxScrollTop);
            }
            else {
                setVerticalSpacing();
            }


            // Now, we can display the new list of answer options.
            showAnswerList(true);

            // Read if was an Edit action
            let isEditAction = store.getters["ChatBotStore/getIsEditAction"];
            // Reset the 'ChatBotStore/setIsEditAction' to false. Use 'isEditAction' once until new manual set
            store.commit('ChatBotStore/setIsEditAction', false);

            // Don't scroll at Edit action
            if (isEditAction !== true) {

                // iOS Safari make scroll also when is not more content to have scroll.
                // Make the test to do the scroll only when is needed.
                let heightOverVisibleArea = getHeightOverVisibleArea();
                if (heightOverVisibleArea > 0 && firstConvMsgPreparedForSticky !== null) {

                    // Make sure the page is scrolled to the last question after padding Top and Bottom was set.
                    let newScrollValue = firstConvMsgPreparedForSticky.offsetTop;

                    Vue.UtilitiesPlugin.smoothScrollTo(newScrollValue);
                }
            }

            refreshIsMoreContentAvailable();
        });
    };



    let productListUpdated = (mustSetSpacingOnly) => {

        waitForLastConvMsgToExist().then(() => {

            let firstConvMsgPreparedForSticky = document.querySelector('.chatbot-conversation-msg-list .conversation-msg.conversation-msg--prepared-for-sticky');

            // Now, we can display the new list of answer options.
            showAnswerList(true);

            // Read if was an Edit action
            let isEditAction = store.getters["ChatBotStore/getIsEditAction"];
            // Reset the 'ChatBotStore/setIsEditAction' to false. Use 'isEditAction' once until new manual set
            store.commit('ChatBotStore/setIsEditAction', false);

            // Don't scroll at Edit action
            if (isEditAction !== true) {

                // iOS Safari make scroll also when is not more content to have scroll.
                // Make the test to do the scroll only when is needed.
                let heightOverVisibleArea = getHeightOverVisibleArea();
                if (heightOverVisibleArea > 0 && firstConvMsgPreparedForSticky !== null) {

                    // Make sure the page is scrolled to the last question after padding Top and Bottom was set.
                    let newScrollValue = firstConvMsgPreparedForSticky.offsetTop;

                    Vue.UtilitiesPlugin.smoothScrollTo(newScrollValue);
                }
            }

            refreshIsMoreContentAvailable();
        });
    };


    let getHeightOverVisibleArea = () => {

        let windowHeight = window.innerHeight;
        let pageHeaderHeight = document.querySelector('.chatbot-page-header nav').offsetHeight;
        let convList = document.querySelector('.chatbot-conversation-msg-list');
        let answerListInnerH = getAnswerListInnerHeight();

        let contentHeight = pageHeaderHeight + convList.offsetHeight + answerListInnerH;
        return contentHeight - windowHeight;
    };

    let setVerticalSpacing = (mustForceAlignBottom) => {

        let windowHeight = window.innerHeight;

        let pageHeaderHeight = document.querySelector('.chatbot-page-header nav').offsetHeight;
        let convList = document.querySelector('.chatbot-conversation-msg-list');
        let answerList = document.querySelector('.chatbot-answer-list');

        let convListCrtPaddingTop = parseInt(window.getComputedStyle(convList).getPropertyValue('padding-top'));
        let convListCrtPaddingBottom = parseInt(window.getComputedStyle(convList).getPropertyValue('padding-bottom'));
        let convListContentHeight = convList.clientHeight - convListCrtPaddingTop - convListCrtPaddingBottom;

        let elemLastConversationMessage;
        let elemLastConvRect;

        if (mustForceAlignBottom !== true) {
            elemLastConversationMessage = document.querySelector('.chatbot-conversation-msg-list .conversation-msg--last');
            elemLastConvRect = elemLastConversationMessage.getBoundingClientRect();
        }

        let answerListInnerH = getAnswerListInnerHeight();

        let newPaddingTop = 0;
        let newPaddingBottom = 0;

        if (pluginData.oldConversationMsgCount === 0) {
            newPaddingTop = windowHeight - pageHeaderHeight - convListContentHeight - answerListInnerH;
        }
        else {
            if (mustForceAlignBottom !== true) { // When mustForceAlignBottom is TRUE, let newPaddingBottom to stay 0, as defined above.
                newPaddingBottom = windowHeight - elemLastConvRect.bottom - answerListInnerH;
                if (newPaddingBottom < 0) {
                    newPaddingBottom = 0;
                }
            }

            newPaddingTop = windowHeight - pageHeaderHeight - convListContentHeight - answerListInnerH - newPaddingBottom;
        }

        if (newPaddingTop < 0) {
            newPaddingTop = 0;
        }

        convList.style.paddingBottom = newPaddingBottom + 'px';
        convList.style.paddingTop = newPaddingTop + 'px';
        answerList.style.minHeight = '';
    };

    /**
     * answerList element has a minHeight, so, it can hide its new Height until is reset the minHeight
     * But resetting the minHeight will make Question to go down in Chatbot and this is not wanted.
     *
     * Calculate the answerList height by its internal elements
     * @returns the answer list height
     */
    let getAnswerListInnerHeight = () => {

        let elemAnswerListProducts = document.querySelector('.answer-list-products');
        let elemAnswerListGenericQuestion = document.querySelector('#answerListGenericQuestionId');
        let elemAnswerListMainSymptom = document.querySelector('.answer-list-main-symptom');
        let elemRelatedSymptomListRelatedSymptoms = document.querySelector('#relatedSymptomListId');
        let elemAnswerListNoOtherSymptoms = document.querySelector('.answer-list-no-other-symptoms');
        let elemAnswerListEvaluationBtn = document.querySelector('.answer-list-evaluation-btn');

        let answerList = document.querySelector('#chatbotAnswerListId');
        let answerListPaddingTop = parseInt(window.getComputedStyle(answerList).getPropertyValue('padding-top'));

        let answerListInnerH =
            elemAnswerListProducts.offsetHeight +
            elemAnswerListGenericQuestion.offsetHeight +
            elemAnswerListMainSymptom.offsetHeight +
            elemRelatedSymptomListRelatedSymptoms.offsetHeight +
            elemAnswerListNoOtherSymptoms.offsetHeight +
            elemAnswerListEvaluationBtn.offsetHeight +
            answerListPaddingTop;

        return answerListInnerH
    };


    /**
     * Show answer list with an animation.
     * @param {Boolean} mustShowImmediately (default: false) - If this is true, show the answer list immediatelly. Otherwise, postpone showing the answer list until the last conversation message has been shown.
     */
    let showAnswerList = (mustShowImmediately) => {

        if (typeof mustShowImmediately === "undefined") {
            mustShowImmediately = false;
        }

        let showAnswerListNow = () => {
            let chatbotPageContentElem = document.querySelector(".chatbot-page-content");
            chatbotPageContentElem.classList.add("animate-show-answer-list");
            chatbotPageContentElem.classList.remove("animate-hide-answer-list");
        };

        if (mustShowImmediately === true) {
            showAnswerListNow();
        } else {
            // Postpone showing the answer list until the last conversation message has been shown.
            waitForLastConvMsgToExist(true).then(showAnswerListNow);
        }
    };
    /**
     * Hide answer list with an animation.
     */
    let hideAnswerList = () => {

        let chatbotPageContentElem = document.querySelector(".chatbot-page-content");

        chatbotPageContentElem.classList.add("animate-hide-answer-list");
        chatbotPageContentElem.classList.remove("animate-show-answer-list");
    };


    let animateBeforeAppendConversationMsg = (el) => {
        el.classList.add("conversation-msg--animate-before-show");
    };

    let animateAppendConversationMsg = (crtConvMsgElem, done) => {

        let promise = new Promise((resolve, reject) => {

            let crtElemIndexExceptAlreadyAppended = crtConvMsgElem.dataset.index - pluginData.oldConversationMsgCount;

            let crtMsgDelay = crtElemIndexExceptAlreadyAppended * 200;

            setTimeout(function () {
                if (crtConvMsgElem.dataset.index === "0") {

                    let windowHeight = window.innerHeight;
                    let pageHeaderHeight = document.querySelector('.chatbot-page-header nav').offsetHeight;

                    let convList = document.querySelector('.chatbot-conversation-msg-list');

                    let convListCrtPaddingTop = parseInt(window.getComputedStyle(convList).getPropertyValue('padding-top'));
                    let convListCrtPaddingBottom = parseInt(window.getComputedStyle(convList).getPropertyValue('padding-bottom'));
                    let convListContentHeight = convList.clientHeight - convListCrtPaddingTop - convListCrtPaddingBottom;

                    let newPaddingTop = windowHeight - pageHeaderHeight - convListContentHeight;

                    if (newPaddingTop < 0) {
                        newPaddingTop = 0;
                    }

                    convList.style.paddingTop = newPaddingTop + 'px';
                }

                crtConvMsgElem.classList.add("conversation-msg--animate-show");

                resolve();

            }, crtMsgDelay);
        });

        return promise;
    };


    // ==================================
    // Scroll Down button
    // ==================================

    let setScrollDownBtnHorizPosition = () => {
        let scrollDownArrowElem = document.querySelector('.root-pf-chatbot .btn-scroll-down');

        if (!scrollDownArrowElem) {
            return;
        }

        if (window.innerWidth < 600) {
            // For screens with the width smaller than 600px, override css value. This is because the algorithm from css doesn't handle properly screens smaller than 600px.
            scrollDownArrowElem.style.right = "24px";
        }
        else {
            // For screens bigger than 600 px, do not override "right" property for scroll down element, just use the default value from css (for performance reason).
            scrollDownArrowElem.style.right = "";
        }
    };


    /**
     * Commits ChatBotStore/setMoreContentAvailable with true or false. This will show or hide the Scroll Down icon/button.
     *
     * @param {Boolean} mustRefreshImmediately (default: false) - If this is true, refresh "More content" immediatelly. Otherwise, postpone the refresh until the answer list is shown. We might want this param to be TRUE when the function is called from onScroll handler.
     * @return {Void}
     */
    let refreshIsMoreContentAvailable = (mustRefreshImmediately) => {

        if (typeof mustRefreshImmediately !== "boolean") {
            mustRefreshImmediately = false;
        }

        let refreshIsMoreContentAvailableNow = () => {

            setScrollDownBtnHorizPosition();

            let chatbotPageContentElem = document.querySelector(".chatbot-page-content"); // animate-hide-answer-list
            if (chatbotPageContentElem.classList.contains("animate-hide-answer-list")) {
                store.commit('ChatBotStore/setMoreContentAvailable', false);
            }
            else {
                let scrollHeight = Math.max(
                    document.body.scrollHeight,
                    document.body.offsetHeight,
                    document.documentElement.clientHeight,
                    document.documentElement.scrollHeight,
                    document.documentElement.offsetHeight
                );

                let maxScrollTop = scrollHeight - window.innerHeight;
                let crtScrollTop = document.documentElement.scrollTop; // window.scrollY

                if (maxScrollTop > 2) {
                    if (crtScrollTop < maxScrollTop-1) {
                        store.commit('ChatBotStore/setMoreContentAvailable', true);
                    }
                    else {
                        store.commit('ChatBotStore/setMoreContentAvailable', false);
                    }
                }
                else {
                    store.commit('ChatBotStore/setMoreContentAvailable', false);
                }
            }
        };

        if (mustRefreshImmediately === true) {
            refreshIsMoreContentAvailableNow();
        }
        else {
            waitForAnswerListToBeShown().then(refreshIsMoreContentAvailableNow);
        }
    };


    /**
     * Adds the hide-scroll to the main page in pathfinder. This class blocks the scroll of the page
     * usually when a popup appears
    * */
    let hideScroll = () => {
        let rootElement = document.getElementsByClassName('root-pf-chatbot')[0];
        if(rootElement) {
            rootElement.classList.add('hide-scroll');
        }
    };


    /**
     * Removes the hide-scroll to the main page in pathfinder. This class blocks the scroll of the page
     * usually when a popup appears
     * */
    let showScroll = () => {
        let rootElement = document.getElementsByClassName('root-pf-chatbot')[0];
        if(rootElement) {
            rootElement.classList.remove('hide-scroll');
        }
    };



    // ==================================
    // Export
    // ==================================

    Vue.mixin({
        computed: {
            PfChatbotPlugin: () => {
                return {
                    handleOnAnswerListUpdated: answerListUpdated,
                    handleOnProductListUpdated: productListUpdated,
                    handleAnswerClick: handleAnswerClick,
                    setVerticalSpacing: setVerticalSpacing,

                    animateBeforeAppendConversationMsg: animateBeforeAppendConversationMsg,
                    animateAppendConversationMsg: animateAppendConversationMsg,
                    hideAnswerList: hideAnswerList,

                    refreshIsMoreContentAvailable: refreshIsMoreContentAvailable,

                    hideScroll: hideScroll,
                    showScroll: showScroll
                }
            }
        }
    });


};

export default PfChatbotPlugin;



// WEBPACK FOOTER //
// ./src/common/plugins/pathfinder/PfChatbotPlugin.js